import React from "react";
import ReactDOM from "react-dom";
import { v4 as uuid_v4 } from "uuid";

import Close from '../assets/image/close.svg';

import "./Modal.css";

const Modal = (props) => {
if(props.tags !== undefined) {
  const tagItems = [
    ...new Set([].concat(props.tags.map((item) => item.tags)).flat()),
  ];
  console.log(tagItems)
}



const content = (
    <div className={`modal-container ${props.className}`}  style = {props.style}>
      <div className={`modal-content ${props.classContent}`}>
        <img className="close" src={Close} alt="close" onClick={props.Close}/>
        <img src={props.img} alt={props.title} />
        <p className="modal-content-date">{props.date}</p>
        <h2 className={`modal-content-title ${props.classContent}`}>{props.title}</h2>
        <p className="modal-content-desc">{props.desc}</p>
        <div className={`modal-content-tags ${props.classContent}`}>
          {props.tags !== undefined  && props.tags.map((tag) => (
            <p className={`modal-content-tag ${props.classContent}`} key={uuid_v4()}>
              {tag}
            </p>
          ))}
          
        </div>
      </div>
    </div>
  );
  return ReactDOM.createPortal(content, document.getElementById("modal-hook"));
};

export default Modal;
